import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { ErrorPageCode, isErrorPageCode } from './error.type';
import { inject } from '@angular/core';

export const errorCodeResolver: ResolveFn<ErrorPageCode> = (route) => {
  const router = inject(Router);
  const code = Number(route.paramMap.get('code')) || null;

  if (!code || !isErrorPageCode(code)) return new RedirectCommand(router.parseUrl('/error/404'));

  return code;
};
